import $ from "jquery";
import { HAT_COLOR } from "../constants/selectors";

export function clickOnDefaultSwatch(name: string) {
	const selectorName = `${HAT_COLOR} span[data-val="${name}"]`;
	const element = $(selectorName);
	element.trigger("click");
}
